import { jsx as n } from "react/jsx-runtime";
import { forwardRef as r } from "react";
import { P as a, S as e, T as s, G as c } from "./DecoratedButton-D1hX-3Iw.mjs";
import "./ArrowButton-DqViaPQ-.mjs";
const u = r((t, o) => /* @__PURE__ */ n(a, { buttonType: "rds-icon-button", ref: o, ...t }));
u.displayName = "PrimaryIconButton";
const i = r((t, o) => /* @__PURE__ */ n(e, { buttonType: "rds-icon-button", ref: o, ...t }));
i.displayName = "SecondaryIconButton";
const y = r((t, o) => /* @__PURE__ */ n(s, { buttonType: "rds-icon-button", ref: o, ...t }));
y.displayName = "TertiaryIconButton";
const d = r((t, o) => /* @__PURE__ */ n(c, { buttonType: "rds-icon-button", ref: o, ...t }));
d.displayName = "GhostIconButton";
export {
  d as G,
  u as P,
  i as S,
  y as T
};
